var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-sub-range"},[_c('div',{staticClass:"module-sub-range-name"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('div',{staticClass:"module-sub-range-value"},[_c('span',{staticClass:"module-sub-range-value-item"},[_vm._v(_vm._s(_vm.min))]),_vm._v(" "),_c('span',[_vm._v("~")]),_vm._v(" "),_c('span',{staticClass:"module-sub-range-value-item"},[_vm._v(_vm._s(_vm.max))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464da48e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/module/sub/Range.vue
// module id = null
// module chunks = 